import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "xmarkIcon", "issueIcon", "label"];

  connect() {
    this.updateIcons();
    this.element.addEventListener("change", () => this.updateIcons());
  }

  updateIcons() {
    if (this.checkboxTarget.checked) {
      this.xmarkIconTarget.classList.add("hidden");
      this.issueIconTarget.classList.remove("hidden");
      this.labelTarget.classList.remove("line-through", "text-danger/50");
      this.labelTarget.classList.add("no-underline", "text-danger");
    } else {
      this.xmarkIconTarget.classList.remove("hidden");
      this.issueIconTarget.classList.add("hidden");
      this.labelTarget.classList.add("line-through", "text-danger/50");
      this.labelTarget.classList.remove("no-underline", "text-danger");
    }
  }
}
